<template>
  <page-template>

    <holiday-calendar/>

  </page-template>
</template>

<script>
import PageTemplate from '@/spa/components/page-template/PageTemplate';
import HolidayCalendar from './calendar/HolidayCalendar';

export default {
  name: 'BoardHoliday',
  components: {
    HolidayCalendar,
    PageTemplate,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/components/board/holiday/BoardHoliday.vue